import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { PaymentGateway } from "../../../components";
import { GeneralContext } from "../../../contexts/general.context";
import { EnglishProficiencyContext } from "../../../contexts/englishProficiency";

export const PaymentModal = ({ onClose, modal }) => {
  const navigate = useNavigate();

  const {
    setSelectedFile,
    initializePaymentSchema,
    setInitializePaymentSchema,
  } = useContext(GeneralContext);

  const { englishProficiencyInfo, setEnglishProficiencyInfo, setCopyType } =
    useContext(EnglishProficiencyContext);

  const config = {
    email: englishProficiencyInfo.destinationEmail,
  };

  const closeHandler = () => {
    onClose((prevStep) => prevStep - 1);
  };

  const handleSubmission = () => {
    navigate("/dashboard/home");

    //resetting transcript state logic
    setEnglishProficiencyInfo({});
    setCopyType();
    setSelectedFile("");
    setInitializePaymentSchema({});
  };


  return (
    <>
      <PaymentGateway
        onPayment={handleSubmission}
        onPrevious={closeHandler}
        config={config}
        modal={modal}
        initializePaymentObject={initializePaymentSchema}
      />
    </>
  );
};
